import {Aerosync, Options} from './Aerosync';

export function openWidget(options: Options): Aerosync {

      return new window.Aerosync(options);
}

export type widget = Aerosync;
window.Aerosync = Aerosync;